import {
  CLEAR_COGNITO_USER_DATA,
  SET_COGNITO_USER_DATA,
  SET_COGNITO_USER_DATA_ERROR,
  SET_COGNITO_USER_DATA_LOADING,
} from "../actions/ActionTypes";

/**
 * Initial state for Cognito user data
 * Stores servicers, owners, vendors and related data fetched from /user/{cognitoId} endpoint
 */
const initialState = {
  // The raw user data object from the API
  userData: null,
  // Flattened servicers array for easy access
  servicers: [],
  // Owners array for easy access
  owners: [],
  // Vendors array for easy access
  vendors: [],
  // Cognito user ID
  cognitoId: null,
  // Loading state
  loading: false,
  // Error message if fetch failed
  error: null,
  // Timestamp of last fetch
  lastFetched: null,
};

/**
 * Reducer for Cognito user data
 * Handles storing and clearing user servicers data from the authentication API
 */
const CognitoUserDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COGNITO_USER_DATA_LOADING:
      return {
        ...state,
        loading: action.loading,
        // Clear error when starting a new load
        error: action.loading ? null : state.error,
      };

    case SET_COGNITO_USER_DATA:
      return {
        ...state,
        userData: action.userData,
        servicers: action.userData?.servicers || [],
        owners: action.userData?.owners || [],
        vendors: action.userData?.vendors || [],
        cognitoId: action.userData?.cognitoId || null,
        loading: false,
        error: null,
        lastFetched: new Date().toISOString(),
      };

    case SET_COGNITO_USER_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case CLEAR_COGNITO_USER_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default CognitoUserDataReducer;
